import { jsx as _jsx } from "react/jsx-runtime";
import MaskInput from "react-maskinput";
import styled from "styled-components";
import { noop } from "../../use-calendar/helpers";
export const StyledMultiDateWrapper = styled.div `
  display: flex;
  flex-direction: row;
  div {
    margin-right: 1rem;
    width: 85px;
  }
`;
export const StyledMaskInput = styled((props) => (_jsx(MaskInput, Object.assign({}, props, { onBlur: props.onBlur || noop, onFocus: props.onFocus || noop })))) `
  font-family: 'AktivGrotesk',helvetica,arial,sans-serif;
  margin: 0;
  font-size: 0.875rem;
  height: 2.5rem;
  padding: 0 1rem 0 0.5rem;
  box-sizing: border-box;
  -webkit-appearance: none;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0;
  border: 1px solid
    ${({ $selected, $error, theme, $show, $isRangePicker, value }) => $error
    ? theme.colors.error
    : $selected ||
        ($show && !$isRangePicker) ||
        ($isRangePicker && $show && value.length !== 10)
        ? theme.colors.black
        : theme.colors.grey10};
  color: ${({ $selected, theme }) => $selected
    ? theme.colors.black
    : `rgba(${theme.colors.transparentBlack}, 0.36);`};
  outline: none;
  margin: 0;

  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }

${({ value, theme }) => !!value && `color: ${theme.colors.black}`};

  svg {
    fill: ${({ theme }) => theme.colors.black};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.grey03};
    border: 1px solid ${({ theme }) => theme.colors.grey14};
  }

  &:focus {
    background: ${({ theme }) => theme.colors.white};

    ${({ $focusVisible, theme }) => $focusVisible
    ? `border: 1px solid ${theme.colors.primaryLight};
    outline: 1px solid ${theme.colors.primaryLight};
    `
    : ""}
  &:active {
    background: ${({ theme }) => theme.colors.grey05};
    border: 1px solid ${({ theme }) => theme.colors.black};
  }

  .disabled {
    background: ${({ theme }) => theme.colors.grey03};
    border: 1px solid transparent;
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
    svg {
      fill: 1px solid rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
    }
  }

  .readonly {
    background: ${({ theme }) => theme.colors.grey04};
    border: 1px solid transparent;
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
    svg {
      display: none;
    }
  }

  .error {
    background: ${({ theme }) => theme.colors.grey04};
    border: 1px solid ${({ theme }) => theme.colors.error};
    svg {
      display: none;
    }
  }
`;
export const StyledDateInputWithIcon = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  label {
    color: ${({ theme }) => theme.colors.grey13};

    &:first-child {
      margin-bottom: 0.25rem;
      color: ${`rgba(${({ theme }) => theme.colors.transparentBlack},0.36)`};
    }
  }
  .error-msg {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.error};
  }
  button {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: ${({ withLabel }) => (withLabel ? "1.25rem" : "0")};
    height: 2.5rem;
    display: flex;
    width: 2.5rem;
    justify-content: center;
    span {
      display: flex;
      align-items: center;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`;
